import type { NewAsset } from 'owa-timestream-asset-sdk-types';
import type { FileLinkPayload } from '../schema';

import { createNewPickerAsset } from 'owa-timestream-asset-sdk-filepicker';

export default async function createNewFileAsset(
    pageX: number,
    pageY: number
): Promise<NewAsset<FileLinkPayload>[] | null> {
    return createNewPickerAsset('file');
}
